<section id="ceremonia" class="ceremonia menu-beige">

  <h2 class="ceremonia-title writing-title">
    Ceremonia
  </h2>

  <div class="ceremonia-content">

    <!-- =========================
         LEWA STRONA
         ========================= -->

    <div class="ceremonia-left">

      <div class="ceremonia-collage">
        <!-- ZDJĘCIE KATEDRY -->
        <div class="katedra-foto reveal reveal-2">
          <img
            src="../images/katedra.jpg"
            alt="Katedra św. Jana Chrzciciela we Wrocławiu"
            class="katedra-zdjecie"
          >
        </div>


        <!-- KOPERTA -->
        <img
          src="../images/koperta.png"
          alt="Koperta"
          class="koperta reveal reveal-1"
        >


        <!-- MAPA -->
        <a
          href="https://www.google.com/maps/search/?api=1&query=Katedra+Św.+Jana+Chrzciciela+Wrocław"
          target="_blank"
          rel="noopener noreferrer"
          class="mapa-link reveal reveal-3"
        >

          <div class="mapa-kartka">

            <div class="mapa-opis">
              Kliknij, aby zobaczyć dojazd
            </div>

            <img
              src="../images/mapa.png"
              alt="Mapa do Katedry Św. Jana Chrzciciela"
              class="mapa"
            >

            <div class="mapa-adres">
              Plac Katedralny 18, Wrocław
            </div>

          </div>

        </a>


        <!-- KARTKA -->
        <div class="kartka reveal reveal-4">

          <div class="kartka-data">
            17.07.2027
          </div>

          <div class="kartka-tekst">
            Katedra<br>
            św. Jana Chrzciciela<br>
            we Wrocławiu
          </div>

          <div class="kartka-godzina">
            15:15
          </div>

          <div class="kartka-maly-tekst">
            Tu powiemy sobie<br>
            najważniejsze "TAK".
          </div>

          <div class="kartka-podpis">
            MAJA & MACIEJ
          </div>

        </div>

      </div>

    </div>


    <!-- =========================
         PRAWA STRONA
         ========================= -->

    <div class="ceremonia-right reveal reveal-from-right reveal-delay-3">

      <p class="ceremonia-text">
        Katedra PW. Św. Jana Chrzciciela <br> znajduje się we Wrocławiu
        na Placu Katedralnym 18.
      </p>

      <p class="ceremonia-text">
        Uprzejmie prosimy o niesypanie ryżu, <br>
        konfetti, płatków kwiatów ani innych materiałów
        przed katedrą.<br>
        Obowiązujące zasady obiektu nie pozwalają
        na takie formy świętowania.<br>
        Największym prezentem będzie dla nas
        Wasza obecność!
      </p>

      <div class="heart">
        ♡
      </div>

      <a href="#rsvp" class="rsvp-button">
        Potwierdź obecność!
      </a>

    </div>

  </div>

</section>


<style>

  /* =========================
     CAŁA SEKCJA
     ========================= */

  .ceremonia {
    box-sizing: border-box;

    background-color: #e6e4dd;

    padding: clamp(4em, 6vw, 6em) 6vw
             clamp(3em, 5vw, 5em);
  }


  /* =========================
     NAGŁÓWEK
     ========================= */

  .ceremonia-title {
    position: relative;
    z-index: 10;

    width: min(100%, 1450px);

    margin:
      -0.25em auto
      -0.05em;

    font-family: "WindSong", cursive;

    font-size: clamp(4em, 6vw, 6em);
    font-weight: 500;

    white-space: nowrap;

    transform: rotate(-4deg);
    transform-origin: left center;
  }


  /* =========================
     DWIE KOLUMNY
     ========================= */

  .ceremonia-content {
    width: min(100%, 1450px);

    margin: 0 auto;

    display: grid;

    grid-template-columns:
      minmax(0, 1fr)
      minmax(0, 1fr);

    gap: clamp(3em, 7vw, 7em);

    align-items: center;
  }


  /* =========================
     LEWA STRONA
     ========================= */

  .ceremonia-left {
    width: 100%;

    display: flex;
    justify-content: center;
    align-items: center;
  }

  /* =========================
    ZDJĘCIE KATEDRY
    ========================= */

  .katedra-foto {
    position: absolute;

    width: 35%;

    left: 30%;
    top: -10%;

    z-index: 2;

    box-sizing: border-box;

    padding: 1.5%;

    background-color: #f7f3e8;

    transform: rotate(-5deg);

    box-shadow:
      0 6px 15px rgba(0, 0, 0, 0.08);
  }


  .katedra-zdjecie {
    display: block;

    width: 100%;
    height: auto;

    /* delikatna sepia */
    filter:
      sepia(100%)
      saturate(80%)
      contrast(95%);
  }
  /* =========================
     KOLAŻ
     ========================= */

  .ceremonia-collage {
    position: relative;

    width: min(100%, 700px);

    /*
      Zamiast stałej wysokości:
      proporcje kolażu pozostają zawsze takie same
    */
    aspect-ratio: 700 / 540;

    margin: 0 auto;
  }


  /* =========================
     KOPERTA
     ========================= */

  .koperta {
    position: absolute;

    width: 68%;
    height: auto;

    left: 11%;
    bottom: 0;

    z-index: 1;

    transform: rotate(-5deg);
  }


  /* =========================
     MAPA
     ========================= */

  .mapa-link {
    position: absolute;

    width: 56%;

    left: 10%;
    top: 45%;

    z-index: 3;

    display: block;

    text-decoration: none;
    color: black;

    transform: rotate(-5deg);

    transition: transform 0.3s ease;
  }


  .mapa-link:hover {
    transform: rotate(-5deg) scale(1.03);
  }


  /* KARTKA Z MAPĄ */

  .mapa-kartka {
    width: 100%;

    box-sizing: border-box;

    background-color: #f7f3e8;

    padding:
      clamp(6px, 1.3vw, 14px)
      clamp(6px, 1.3vw, 14px)
      clamp(10px, 2vw, 22px);

    border: 1px solid #d8d0c0;

    box-shadow:
      0 6px 15px rgba(0, 0, 0, 0.08);
  }


  .mapa-opis {
    margin-bottom:
      clamp(4px, 0.8vw, 10px);

    font-family: "Cormorant Garamond", serif;

    font-size:
      clamp(0.65rem, 1.2vw, 0.95rem);

    text-align: center;

    letter-spacing: 0.04em;
  }


  .mapa {
    display: block;

    width: 100%;
    height: auto;
  }


  .mapa-adres {
    margin-top:
      clamp(5px, 1vw, 12px);

    font-family: "Cormorant Garamond", serif;

    font-size:
      clamp(0.6rem, 1.1vw, 0.9rem);

    text-align: center;

    letter-spacing: 0.05em;
  }


  /* =========================
     KARTKA Z INFORMACJĄ
     ========================= */

  .kartka {
    position: absolute;

    width: 41%;

    right: 1%;
    top: 8%;

    z-index: 4;

    box-sizing: border-box;

    /*
      dzięki aspect-ratio kartka zachowuje proporcje
      i nie potrzebujemy min-height w px
    */
    aspect-ratio: 285 / 410;

    padding: 6% 4%;

    background-color: #f4ecd5;

    transform: rotate(8deg);

    display: flex;
    flex-direction: column;

    align-items: center;
    justify-content: space-between;

    text-align: center;

    box-shadow:
      0 5px 14px rgba(0, 0, 0, 0.06);
  }


  .kartka-data {
    font-family: "Cinzel", serif;

    font-size:
      clamp(0.45rem, 1vw, 0.8rem);

    letter-spacing: 0.1em;
  }


  .kartka-tekst {
    font-family: "The Seasons", serif;

    font-size:
      clamp(0.75rem, 1.8vw, 1.45rem);

    line-height: 1.05;
  }


  .kartka-godzina {
    font-family: "Cinzel", serif;

    font-size:
      clamp(0.9rem, 2.2vw, 1.8rem);

    font-weight: 600;

    letter-spacing: 0.08em;
  }


  .kartka-maly-tekst {
    font-family: "Cormorant Garamond", serif;

    font-size:
      clamp(0.65rem, 1.4vw, 1rem);

    line-height: 1.15;
  }


  .kartka-podpis {
    font-family: "Cormorant Garamond", serif;

    font-size:
      clamp(0.5rem, 1.1vw, 0.9rem);

    letter-spacing: 0.1em;
  }

  /* =========================
   ANIMACJA POJAWIANIA
   ========================= */

  .reveal {
    opacity: 0;
     translate: 0 30px;

    transition:
      opacity 0.8s ease,
      translate 0.8s ease,
      scale 0.8s ease;
  }

  .reveal.visible {
    opacity: 1;

    translate: 0 0;
    scale: 1;
  }


  /* kolejne opóźnienia */

  .reveal-1 {
    translate: 0 80px;
    scale: 0.92;
    transition-delay: 0.15s;
  }

  .reveal-2 {
    translate: -80px 0;
    scale: 0.95;

    transition-delay: 0.35s;
  }

  .reveal-3 {
    translate: 80px 0;
    scale: 0.95;

    transition-delay: 0.5s;
  }

  .reveal-4 {
    translate: 0 -70px;
    scale: 0.9;

    transition-delay: 0.65s;
  }


  /* =========================
     PRAWA STRONA
     ========================= */

  .ceremonia-right {
    width: 100%;

    display: flex;
    flex-direction: column;

    align-items: center;
    justify-content: center;

    gap: clamp(1.8em, 3vw, 3em);

    text-align: center;
  }


  .ceremonia-text {
    width: min(100%, 550px);

    margin: 0;

    font-family: "Cormorant Garamond", serif;

    font-size:
      clamp(1.15em, 1.7vw, 1.5em);

    font-weight: 400;

    line-height: 1.4;

    letter-spacing: 0.04em;
  }


  /* =========================
     SERCE
     ========================= */

  .heart {
    font-size:
      clamp(3em, 5vw, 5em);

    line-height: 0.8;
  }


  /* =========================
     RSVP
     ========================= */

  .rsvp-button {
    display: block;

    width: min(90%, 500px);

    box-sizing: border-box;

    padding: 1.1em 2em;

    background-color: #f4ecd5;

    border: 1px solid #cfc6ad;
    border-radius: 14px;

    color: black;

    font-family: "Cormorant Garamond", serif;

    font-size:
      clamp(1.05em, 1.4vw, 1.3em);

    font-weight: 600;

    text-align: center;
    text-decoration: none;

    transition:
      transform 0.2s ease,
      background-color 0.2s ease;
  }


  .rsvp-button:hover {
    transform: translateY(-3px);

    background-color: #eee2c3;
  }


  /* =========================
     TABLET / TELEFON
     ========================= */

  /* =========================
   TABLET / TELEFON
   ========================= */

@media (max-width: 900px) {

  .ceremonia {
    width: 100%;
    max-width: 100%;

    padding: 6em 1.5em 3.5em;

    box-sizing: border-box;

    /* zabezpieczenie przed poziomym scrollem */
    overflow-x: hidden;
  }


  /* TYTUŁ */

  .ceremonia-title {
    position: relative;
    z-index: 10;

    width: 100%;

    margin: -0.5em auto 1.5em;

    text-align: center;

    transform: rotate(-3deg);
    transform-origin: center;
  }


  /* Z 2 KOLUMN ROBIMY 1 */

  .ceremonia-content {
    width: 100%;
    max-width: 100%;

    grid-template-columns: minmax(0, 1fr);

    gap: 3em;

    box-sizing: border-box;
  }


  .ceremonia-left {
    width: 100%;
    min-width: 0;
  }


  /* KOLAŻ */

  .ceremonia-collage {
    width: min(100%, 620px);

    margin: 0 auto;
  }


  /* PRAWA CZĘŚĆ */

  .ceremonia-right {
    width: 100%;
    max-width: 600px;
    min-width: 0;

    margin: 0 auto;

    padding: 0;

    box-sizing: border-box;
  }


  .ceremonia-text {
    width: 100%;
    max-width: 550px;

    margin-left: auto;
    margin-right: auto;

    box-sizing: border-box;

    overflow-wrap: break-word;
  }


  .rsvp-button {
    width: 100%;
    max-width: 500px;

    box-sizing: border-box;
  }
}


/* =========================
   TELEFON
   ========================= */

@media (max-width: 500px) {

  .ceremonia {
    /*
      16px po lewej i prawej.
      Dzięki temu nic nie dotyka krawędzi ekranu.
    */
    padding:
      5.5em
      1rem
      3em;
  }


  /* =========================
     TYTUŁ
     ========================= */

  .ceremonia-title {
    width: 100%;

    font-size: clamp(3.5em, 16vw, 4.5em);

    margin-top: -0.55em;
    margin-bottom: 0.8em;

    text-align: center;

    transform: rotate(-3deg);
  }


  /* =========================
     KOLAŻ
     ========================= */

  .ceremonia-collage {
    width: 100%;
    max-width: 380px;

    margin: 0 auto;
  }


  .koperta {
    width: 68%;
    left: 11%;
  }


  .mapa-link {
    width: 58%;
    left: 7%;
  }


  .kartka {
    width: 41%;

    right: 1%;
  }


  /* =========================
     TEKST POD KOLAŻEM
     ========================= */

  .ceremonia-right {
    width: 100%;
    max-width: 100%;

    padding: 0 0.5rem;

    box-sizing: border-box;

    gap: 2.3em;
  }


  .ceremonia-text {
    width: 100%;
    max-width: 100%;

    margin: 0;

    padding: 0;

    box-sizing: border-box;

    font-size: 1.15em;
    line-height: 1.45;

    text-align: center;

    /*
      Bardzo ważne:
      tekst nie może rozszerzać kontenera.
    */
    overflow-wrap: anywhere;
  }


  /* =========================
     SERCE
     ========================= */

  .heart {
    font-size: 3.5em;
  }


  /* =========================
     PRZYCISK
     ========================= */

  .rsvp-button {
    width: 100%;
    max-width: 100%;

    padding: 1em 1.25em;

    box-sizing: border-box;

    font-size: 1.1em;
  }
}

</style>

<script>
  const ceremoniaRevealElements =
    document.querySelectorAll("#ceremonia .reveal");

  const ceremoniaRevealObserver = new IntersectionObserver(
    (entries) => {

      entries.forEach((entry) => {

        if (entry.isIntersecting) {

          entry.target.classList.add("visible");

          /* animacja tylko raz */
          ceremoniaRevealObserver.unobserve(entry.target);

        }

      });

    },
    {
      threshold: 0.15
    }
  );


  ceremoniaRevealElements.forEach((element) => {
    ceremoniaRevealObserver.observe(element);
  });
</script>